import { OPTION_REFRESH_STATUS_LABELS } from '@/models';
import type { OptionRefreshStatus } from '@/models';

/** Which outcomes are worth a colour: only ERROR and UNRESOLVED are actual failures. EMPTY (market
 *  closed) and NO_CHAIN (the underlying simply has no listed options) are normal outcomes. */
const STATUS_CLASSES: Record<OptionRefreshStatus, string> = {
  OK: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-200',
  EMPTY: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400',
  NO_CHAIN: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400',
  ERROR: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-200',
  UNRESOLVED: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200',
  NEVER: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-200',
};

interface Props {
  status: OptionRefreshStatus;
  title?: string;
}

/** The outcome of a symbol's last option-contract refresh. Shared by the IB admin page and the
 *  symbol list so the same state does not get two different colours. */
export default function OptionRefreshBadge({ status, title }: Props) {
  return (
    <span
      title={title}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_CLASSES[status]}`}
    >
      {OPTION_REFRESH_STATUS_LABELS[status] ?? status}
    </span>
  );
}
